import React, { Component } from 'react';
import styled from 'styled-components/macro';
import scaleSize from '../../utils/scale-size';

const StyledToast = styled.div`
  width: ${scaleSize(640)}px;
  border-radius: ${scaleSize(16)}px;
  position: absolute;
  left: ${scaleSize(640)}px;
  bottom: ${scaleSize(120)}px;
  text-align: center;
  padding: ${scaleSize(20)}px ${scaleSize(30)}px;
  box-shadow: 0 15px 40px 0 rgba(0, 0, 0, 0.5);
  background: #444444;
  color: #fff;
  z-index: 102;
`;

const StyledText = styled.span`
  font-family: 'RobotoRegular', sans-serif;
  font-size: ${scaleSize(32)}px;
  line-height: 1.5;
`;

class Toast extends Component {
  componentDidUpdate(prevProps, prevState) {
    // TODO think about it
    if (this.props.show) {
      setTimeout(() => {
        this.props.hideToast();
      }, 4000);
    }
  }

  render() {
    const { options, show } = this.props;

    if (!show) {
      return null;
    }

    return (
      <StyledToast>
        <StyledText>{options.toastText}</StyledText>
      </StyledToast>
    );
  }
}

export default Toast;
